import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { navItems, type NavItem } from './nav.config'
import MenuButtonIcon from '@components/MenuButtonIcon/MenuButtonIcon'
import LoginButton from '@components/LoginButton/LoginButton'

import './Nav.css'

export default function Nav() {
  const activeSection = ''
  const [open, setOpen] = useState(false)
  return (
    <nav id="main-nav">
      <MenuButtonIcon handleOpen={setOpen} open={open} />
      <ul className={open ? 'open' : ''}>
        {navItems.map((item: NavItem) => {
          return (
            <li key={item.path}>
              <a
                key={item.name}
                href={item.path}
                className={activeSection === item.name ? 'active' : ''}
              >
                <span onClick={() => setOpen(false)}>
                  <FormattedMessage id={`main-nav.${item.name}`} />
                </span>
              </a>
            </li>
          )
        })}
      </ul>
      <LoginButton />
    </nav>
  )
}
